export default __webpack_public_path__ + "static/media/vk.aef20084.png";